/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

//import { IAquaglideVisibilityContainerData } from './obrien-tabbed-container.data';
import {
    IAquaglideVisibilityContainerProps,
    IAquaglideVisibilityContainerConfig
} from './aquaglide-visibility-container.props.autogenerated';

export interface IAquaglideVisibilityContainerViewProps extends IAquaglideVisibilityContainerProps<IAquaglideVisibilityContainerConfig> {
    visibilityClassName?: string;
    visibilityCategories: React.ReactNode[];
}

/**
 *
 * AquaglideVisibilityContainer component
 * @extends {React.PureComponent<IAquaglideVisibilityContainerProps<IAquaglideVisibilityContainerConfig>>}
 */
class AquaglideVisibilityContainer extends React.PureComponent<IAquaglideVisibilityContainerProps<IAquaglideVisibilityContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const VisibilityClassName = config.visibilityClassName ? config.visibilityClassName : 'No Content';

        const viewprops = {
            ...this.props,
            visibilityClassName: VisibilityClassName,
            visibilityCategories: this.props.slots.visibilitySlot1
        };

        return this.props.renderView(viewprops);
    }
}

export default AquaglideVisibilityContainer;
